import { render } from "./app-header.vue?vue&type=template&id=1d8f671c&scoped=true"
import script from "./app-header.vue?vue&type=script&lang=js"
export * from "./app-header.vue?vue&type=script&lang=js"

import "./app-header.vue?vue&type=style&index=0&id=1d8f671c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8f671c"]])

export default __exports__